export default __webpack_public_path__ + "static/media/7.71b3c727.png";